import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { AppShell } from "@app/components/AppShell.tsx";
import { Home } from "@app/screens/Home.tsx";
import { Game } from "@app/screens/Game.tsx";
import { Result } from "@app/screens/Result.tsx";
import { Stats } from "@app/screens/Stats.tsx";
import { Legal } from "@app/screens/Legal.tsx";
import { ResultShare } from "@app/screens/ResultShare.tsx";
import { NotFound } from "@app/screens/NotFound.tsx";

// El panel va en su propio chunk: los jugadores nunca lo descargan.
const AdminApp = lazy(() => import("@app/admin/AdminApp.tsx"));

export function App() {
  return (
    <Routes>
      <Route
        path="admin/*"
        element={
          <Suspense fallback={<p className="status">Cargando panel…</p>}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route element={<AppShell />}>
        <Route index element={<Home />} />
        <Route path="jugar" element={<Game />} />
        <Route path="resultado" element={<Result />} />
        <Route path="estadisticas" element={<Stats />} />
        <Route path="legal/:page" element={<Legal />} />
        <Route path="r/:shareId" element={<ResultShare />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
